module.exports = __webpack_public_path__ + "img/symbol_12.fb2b82ed.png";